import Phaser, {
    Display
} from 'phaser'


let _this;
let xmlLoader;
let guide;
let guideAnimate;
let thisLocation;
let container;
let isLoaded;
let quizMessaging;

export default class Location extends Phaser.Scene {

    constructor(scene = 'location') {
        super(scene);
    }
    init() {
        _this = this;
        isLoaded = false;

        thisLocation = arguments[0].location;

        xmlLoader = this.scene.get("xmlLoader");
        this.xmlLoader = xmlLoader;
        xmlLoader.loadThis({
            id: thisLocation + 'XML',
            path: '././assets/xml/' + thisLocation + '.xml',
            callback: this.parseXML,
            parent: this,
            name: 'intro'

        });

        this.events.on('start', () => {
            this.cameras.main.fadeIn(300, 0, 0, 0);
        })

    }



    preload() {

    }

    create() {

        container = this.add.container(0, 0);
        let graphics = this.scene.get(thisLocation + 'Graphics');

        if (graphics) {
            graphics.addGraphics(container);
        } else {
            this.scene.add(thisLocation + 'Graphics', this.Graphics, true, {
                container: container,
                location: thisLocation
            });
        }

        this.events.on('pause', this.paused, this);
        this.events.on('resume', this.resume, this);
        this.events.on('shutdown', this.paused, this);
        this.events.on('boot', this.active, this);
    }

    playBackgroundSound() {
        // this.scene.get('sounds').setBackgroundSound(location, 0.05);
    }
    resume() {
        guide.animateBubbleOut();
        this.active();

        //guide.removeBubble();
        //this.scene.bringToTop('guide');
        this.setupGuide(false);

    }

    active() {
        xmlLoader.setSection('intro');
        xmlLoader.events.on('changeSpeech', _this.listenForChange, _this);
        xmlLoader.events.on('endOfSpeech', _this.listenForEnd, _this);
        xmlLoader.events.on('startOfSpeech', _this.listenForStart, _this);

    }
    paused() {
        xmlLoader.events.shutdown();
        this.hideSpeech();
    }

    //This is called once xml has loaded
    parseXML() {
        //Don't start the guide and scene until the images are loaded
        if (!isLoaded) {
            _this.time.delayedCall(100, _this.parseXML, _this);
            return;
        }
        //sound file is loaded in the graphics file
        _this.playBackgroundSound();
        //first load so start on the intro - 1st section
        _this.setupGuide();
        _this.active();
        //Check if there is a quiz
        if (xmlLoader.getSceneAttribute('special')) _this.handleSpecial();
    }

    handleSpecial() {
        let special = xmlLoader.getSceneAttribute('special');
        switch (special) {
            case 'quiz':
                let quizMessaging = this.scene.get(thisLocation + 'QuizMessaging');

                if (quizMessaging) {
                    this.scene.launch(thisLocation + 'QuizMessaging', {
                        thisLocation: thisLocation
                    });
                    this.scene.bringToTop(thisLocation + 'QuizMessaging');
                } else {
                    this.scene.add(thisLocation + 'QuizMessaging', this.Quiz, true, {
                        thisLocation: thisLocation
                    });

                }
                break;

        }
    }


    setupGuide(speak = true) {
        //store reference to guide classes
        guide = this.scene.get('guide');
        guideAnimate = this.scene.get('guideAnimate');

        //Get the settings for this location
        let settings = this.guideSettings();

        //Do we want the guide to speak (or call function)?
        if (!speak) {
            delete settings.callback;
            //Don't walk in again if just reactivating the guide
            delete settings.walk;
        }
        //Change the guide settings for these scene
        guide.setupGuide(settings);

        //Setup the guide button that resets the speech bubbles
        let navigate = this.scene.get('navigate');

        navigate.setupLocation({
            obj: guide.getGuide(),
            callback: this.resetSpeech
        });


    }

    guideSettings() {

        return ({
            id: 'guideProfile',
            walk: true,
            //When the guide is ready showSpeech bubble
            callback: this.showSpeech
        });
    }

    resetSpeech() {
        xmlLoader.setSection('intro');
        _this.showSpeech();
    }

    showSpeech() {
        //There are 2 speakers in this scene
        let speaker = xmlLoader.getSpeaker();
        //position the bubble out of the default settings when it's not marama

        if (speaker != 'marama') {
            guide.speechBubble(_this.otherSpeaker());
        } else {
            guide.speechBubble(_this.maramaSpeaker());
        }
    }

    maramaSpeaker() {
        return ({
            xmlLoader: xmlLoader
        });
    }

    otherSpeaker() {
        return ({
            xmlLoader: xmlLoader,
            flip: true,
            x: 250,
            y: 155,
            speaker: xmlLoader.getSpeaker()
        });
    }

    listenForChange() {
        this.showSpeech();
        guide.getBack().setInteractive();
        guide.getBack().alpha = 1;
    }

    listenForEnd() {
        guide.setNext({
            callback: this.finishSpeech,
            context: this
        });

    }
    listenForStart() {

        //if (numPages == 1) return;
        guide.getBack().disableInteractive();
        guide.getBack().alpha = 0.5;

    }

    hideSpeech() {
        guideAnimate.animateBubbleOut();

    }

    //Guide has run out of xml to show
    finishSpeech() {
        //hide the speech bubbles and arm
        this.hideSpeech();

        //if this location has a quiz....
        quizMessaging = this.scene.get(thisLocation + 'QuizMessaging');
        if (quizMessaging) {
            //And if that quiz has been setup
            if (quizMessaging.getIsSetup()) quizMessaging.resume();
        }

    }

    startToolTips() {
        isLoaded = true;
        let toolTips = this.scene.get('toolTips');
        toolTips.startTips(container);
    }
    getContainer() {
        return (container);
    }

}